import { gql } from '__generated__'

export const GetRosterCandidateClientNotes = gql(/* GraphQL */ `
    query GetRosterCandidateClientNotes(
        $rosterCandidateId: ID!
        $page: Int
        $limit: Int
    ) {
        getRosterCandidateClientNotes(
            rosterCandidateId: $rosterCandidateId
            page: $page
            limit: $limit
        ) {
            data {
                id
                rating
                note
                createdAt
                updatedAt
                createdByUser {
                    preferredName
                    id
                }
            }
            pageInfo {
                pageNumber
                pageTotal
                itemTotal
            }
        }
    }
`)

export const DeleteRosterCandidateClientNote = gql(/* GraphQL */ `
    mutation DeleteRosterCandidateClientNote(
        $rosterCandidateClientNoteId: ID!
    ) {
        deleteRosterCandidateClientNote(
            rosterCandidateClientNoteId: $rosterCandidateClientNoteId
        ) {
            success
            message
        }
    }
`)
